import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../setup/store/store';
import { AppointmentDropIn } from '../models/appointment-drop-in.model';

const appointmentDropInAdapter = createEntityAdapter({
    // easier to use appointmentId other the dropin id
    selectId: (model: AppointmentDropIn) => model.appointmentId,
});

const initialState = appointmentDropInAdapter.getInitialState();

export const appointmentDropInSlice = createSlice({
    initialState,
    name: 'appointmentDropIns',
    reducers: {
        // drop-ins
        appointmentDropInSetOne: appointmentDropInAdapter.setOne,
        appointmentDropInSetMany: appointmentDropInAdapter.setMany,
        appointmentDropInRemoveOne: appointmentDropInAdapter.removeOne,
    },
});

export const appointmentDropInSelectors = appointmentDropInAdapter.getSelectors<RootState>(
    state => state.appointmentDropIns,
);
